import { DraftsTable } from '@/components/Templates/Drafts';

const Drafts = () => {
	return <DraftsTable />;
};

export default Drafts;
